import { useRouter } from "next/router";
import React from "react";
import { SWRConfig } from "swr";
import useLogout from "../hooks/useLogout";
import { toast } from "sonner";
import { getCookie } from "cookies-next";
import config from "@/config";

const SwrProvider = ({ children }: { children?: React.ReactNode }) => {
  const router = useRouter();
  const [hasMounted, setHasMounted] = React.useState(false);

  const logout = useLogout();

  React.useEffect(() => {
    setHasMounted(true);
  }, []);

  if (typeof window === "undefined" || !hasMounted) {
    return <>{children}</>;
  }

  const exempted_paths =
    router.pathname.startsWith("/login") ||
    router.pathname.startsWith("/register") ||
    router.pathname.startsWith("/domains/new");

  const token = getCookie(config.ACCESS_TOKEN);

  return (
    <SWRConfig
      value={{
        onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
          if (!token && !exempted_paths) {
            logout(true);
            return;
          }

          if (error?.response?.status === 403 && !exempted_paths) {
            toast.error(
              error?.response?.data?.message ||
                "You don't have access to view or manage these resources.",
              {
                onAutoClose: () => {
                  router.back();
                },
                duration: 1000,
              },
            );
          }

          if ([401].includes(error?.response?.status) && !exempted_paths) {
            logout(true);
            return;
          }

          if (error?.response?.status >= 400) return;

          if (retryCount >= 3) return;

          setTimeout(() => revalidate({ retryCount }), 5000);
        },
      }}
    >
      {children}
    </SWRConfig>
  );
};

export default SwrProvider;

function localStorageProvider(): any {
  const map = new Map(
    JSON.parse(localStorage.getItem("brimble-app-cache") || "[]"),
  );

  // Before unloading the app, we write back all the data into `localStorage`.
  window.addEventListener("beforeunload", () => {
    const appCache = JSON.stringify(Array.from(map.entries()));
    localStorage.setItem("brimble-app-cache", appCache);
  });

  return map;
}

// export const cacheProvider = (cache: Cache) => {
//   const storage = localStorage
//   const swrCache: Cache<any> = {
//     get: (key) => {
//       const valueFromMap = cache.get(key);
//       if (valueFromMap) {
//         return valueFromMap;
//       }
//       if (typeof key === "string") {
//         const value = storage.getItem(key);
//         return value ? JSON.parse(value) : undefined;
//       }

//       return undefined;
//     },
//     set: (key, value) => {
//       cache.set(key, value);
//       if (typeof key === "string") {
//         storage.setItem(key, JSON.stringify(value));
//       }
//     },
//     delete: (key) => {
//       cache.delete(key);
//       if (typeof key === "string" && ) {
//         storage.removeItem(key);
//       }
//     },
//     keys: function (): IterableIterator<string> {
//       const keys = cache.keys();
//       return keys;
//       // throw new Error("Function not implemented.");
//     },
//   };

//   return swrCache;
// };
